var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons8-twitter",
    transform: "translate(1.000000, 6.000000)",
    fill: "#707E96",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47,4.49717042 C45.2673995,5.26249171 43.4102564,5.77634973 41.4578757,6.00959036 C43.4505497,4.82152044 44.9816847,2.94101786 45.6996335,0.70336604 C43.8388276,1.80032564 41.7692308,2.59844616 39.5750913,3.0284831 C37.8168496,1.16255806 35.3113551,0 32.5384616,0 C27.2124547,0 22.8937732,4.29308487 22.8937732,9.59202089 C22.8937732,10.3427637 22.9816852,11.0752848 23.1465202,11.7786518 C15.1318682,11.377769 8.02930383,7.55845369 3.27106278,1.75294887 C2.43956072,3.17425849 1.96703348,4.82152044 1.96703348,6.5781144 C1.96703348,9.90543752 3.66666718,12.8428122 6.25641006,14.566606 C4.67399248,14.5155841 3.18681346,14.081903 1.88644693,13.3639585 C1.88644693,13.404047 1.88644693,13.4441354 1.88644693,13.4842239 C1.88644693,18.134459 5.21245425,22.0084393 9.61904789,22.8940251 C8.81318709,23.1126882 7.95970747,23.2293085 7.08058659,23.2293085 C6.4578755,23.2293085 5.85348013,23.1709983 5.26373677,23.054378 C6.494506,26.8627599 10.0549456,29.6434258 14.2710621,29.7199576 C10.9743588,32.2928938 6.81685033,33.8235354 2.29670334,33.8235354 C1.5164838,33.8235354 0.750916266,33.7798028 0,33.6886934 C4.26373607,36.4146933 9.33333314,38 14.7802198,38 C32.516484,38 42.2161177,23.3823731 42.2161177,10.7072022 C42.2161177,10.2917428 42.2051284,9.87263829 42.1904764,9.46446719 C44.0732598,8.11240018 45.7069599,6.42140562 47,4.49717042 Z",
    id: "Path"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.cace44321965c6c2179eaa4e75fd4057.svg";
export { ForwardRef as ReactComponent };